<div mat-dialog-content>
    <img src="/assets/images/logo_monaco.png" width="300" alt="Monaco">
    <h4 class="card-title pt-3 mb-3 border-bottom">Medimail Patient en Principauté de Monaco</h4>
    <h6 class='font-weight-bold'>Gouvernement Princier de Monaco</h6>
    <h6 class='font-weight-bold'>Délégation Interministérielle chargée de la Transition Numérique</h6>
    <address>
        Place de la Visitation<br>
        98000 Monaco<br>
        <a href="https://www.monacosante.mc" target="_blank">www.monacosante.mc</a>
    </address>
    <p>Contactez le support d'Extended MonacoSanté sur le mail : <a href='mailto:monacosante@gouv.mc'>monacosante@gouv.mc</a></p>
</div>
